import styled from 'styled-components';

export const Container = styled.div`
  position: relative;

  svg {
    position: absolute;
    top: 15px;
    right: 10px;
    font-size: 16px;
    color: ${(props) => props.theme.colors.gray};
  }

  .react-datepicker__input-container {
    input {
      width: 190px;
      height: 48px;
      color: ${(props) => props.theme.colors.black};
      background: ${(props) => props.theme.colors.white};
      border: 1.5px solid #dfe4ef;
      border-radius: 4px;
      font-weight: 400;
      padding: 0 20px;
      font-size: 16px;

      ::-webkit-input-placeholder {
        color: ${(props) => props.theme.colors.gray};
        padding-top: 5px;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 40px;
      }

      @media screen and (max-width: 960px) {
        width: 150px;
      }
    }
  }

  .react-datepicker__tab-loop {
    .react-datepicker__navigation--next {
      border-left-color: #3c50e0;
    }

    .react-datepicker__navigation--previous {
      border-right-color: #3c50e0;
    }

    .react-datepicker__navigation--next,
    .react-datepicker__navigation--previous {
      margin-top: 8px !important;
    }

    .react-datepicker__header {
      padding: 10px 0 !important;
      background-color: ${(props) => props.theme.colors.white} !important;
    }

    .react-datepicker__current-month,
    .react-datepicker-time__header,
    .react-datepicker-year-header {
      display: none !important;
    }

    select.react-datepicker__year-select,
    select.react-datepicker__month-select {
      border: 1px solid #dfe4ef !important;
      padding: 5px !important;
      border-radius: 4px !important;
      cursor: pointer;
    }

    .react-datepicker__day--selected,
    .react-datepicker__day--in-selecting-range,
    .react-datepicker__day--in-range,
    .react-datepicker__month-text--selected,
    .react-datepicker__month-text--in-selecting-range,
    .react-datepicker__month-text--in-range,
    .react-datepicker__quarter-text--selected,
    .react-datepicker__quarter-text--in-selecting-range,
    .react-datepicker__quarter-text--in-range,
    .react-datepicker__year-text--selected,
    .react-datepicker__year-text--in-selecting-range,
    .react-datepicker__year-text--in-range {
      background-color: #3c50e0 !important;
    }
  }
`;
